import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';
import IdentificationInterstitial from './identification_interstitial.jsx';


const addInterstitialMountNode = ()=> {
  var interstitialMountNode = document.createElement('div');
  interstitialMountNode.setAttribute('id', 'interstitial-mount-point');
  document.body.appendChild(
    interstitialMountNode
  );
  return interstitialMountNode;
};


const removeInterstitialMountNode = (mountNode)=> {
  window.setTimeout(function(){
    ReactDOM.unmountComponentAtNode(mountNode);
    document.body.removeChild(mountNode);
  }, 0);
};


export const renderIdentificationInterstitial = (dataFromServer, reduxStore, onConsentChange, onComplete)=> {

  const mountNode = addInterstitialMountNode();
  ReactDOM.render(
    <Provider store={reduxStore}>
      <IdentificationInterstitial
        routeId={dataFromServer.routeId}
        accountLogoUrl={dataFromServer.accountLogoUrl}
        isConsentRequired={dataFromServer.isConsentRequired}
        isConsentCookieSet={dataFromServer.isConsentCookieSet}
        hasConsentedToTracking={dataFromServer.hasConsentedToTracking}
        hasConsentedToAuthCookie={dataFromServer.hasConsentedToAuthCookie}
        privacyPolicyUrl={dataFromServer.privacyPolicyUrl}
        shouldAskForEmail={dataFromServer.shouldAskForEmail}
        shouldAskForName={dataFromServer.shouldAskForName}
        onConsentChange={onConsentChange}
        onComplete={
          ({ public_user_id })=>{
            removeInterstitialMountNode(mountNode);
            let newTrackerData = { public_user_id };

            if (public_user_id) {
              newTrackerData.type_of_identification = 'via_self_report';
            }

            getTracker().updatePersistentEventData(newTrackerData);
            getTracker().handleSubmitTrackingSplashAndPageRender();

            onComplete();
          }
        }
      />
    </Provider>,
    mountNode
  );

};
